import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI, FI18n } from '@freelog/tools-lib';
import { decompile } from '@freelog/nmr_translator';
import fMessage from '@/components/fMessage';
import type {
  IRules,
  ChangeAction,
  FetchExhibitListAction,
  FetchThemeListAction,
  OnCancel_AddExhibitDrawer_Action,
  OnConfirm_AddExhibitDrawer_Action,
  OnCancel_AddThemeDrawer_Action,
  OnConfirm_AddThemeDrawer_Action,
} from './types';
import { checkedExhibitUsedNames } from './helpers';

export const drawerEffects = {
  * onCancel_AddExhibitDrawer({}: OnCancel_AddExhibitDrawer_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        addExhibitDrawer_Visible: false,
      },
    });
  },
  * onConfirm_AddExhibitDrawer({ payload }: OnConfirm_AddExhibitDrawer_Action, {
    select,
    call,
    put,
  }: EffectsCommandMap) {
    const { informalNodeManagerPage }: ConnectState = yield select(({ informalNodeManagerPage }: ConnectState) => ({
      informalNodeManagerPage,
    }));
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        addExhibitDrawer_Visible: false,
      },
    });

    const rightNames: string[] = yield call(checkedExhibitUsedNames, informalNodeManagerPage.node_ID, payload.names.map((n) => {
      return n.split('/')[1];
    }));

    const ruleObj: Array<IRules['add']> = payload.names.map((n, index) => {
      return {
        operation: 'add',
        exhibitName: rightNames[index],
        candidate: {
          name: n,
          versionRange: 'latest',
          type: payload.identity,
        },
        actions: [],
        text: '',
      };
    });
    const text: string = decompile(ruleObj);
    const params: Parameters<typeof FServiceAPI.InformalNode.putRules>[0] = {
      nodeId: informalNodeManagerPage.node_ID,
      additionalTestRule: text,
    };
    const { data, errCode, ret, msg }: {
      data: boolean;
      errCode: number;
      msg: string;
      ret: number;
    } = yield call(FServiceAPI.InformalNode.putRules, params);

    if (ret !== 0 || errCode !== 0 || !data) {
      return fMessage(msg, 'error');
    }
    fMessage(FI18n.i18nNext.tAuto('msg_new_test_exhibit_added'));
    yield put<FetchExhibitListAction>({
      type: 'fetchExhibitList',
      payload: {
        isRematch: true,
        isRestart: true,
      },
    });
  },
  * onCancel_AddThemeDrawer({}: OnCancel_AddThemeDrawer_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        addThemeDrawer_Visible: false,
      },
    });
  },
  * onConfirm_AddThemeDrawer({ payload }: OnConfirm_AddThemeDrawer_Action, { select, call, put }: EffectsCommandMap) {
    const { informalNodeManagerPage }: ConnectState = yield select(({ informalNodeManagerPage }: ConnectState) => ({
      informalNodeManagerPage,
    }));
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        addThemeDrawer_Visible: false,
      },
    });

    const rightNames: string[] = yield call(checkedExhibitUsedNames, informalNodeManagerPage.node_ID, payload.names.map((n) => {
      return n.split('/')[1];
    }));

    const ruleObj: Array<IRules['add']> = payload.names.map((n, index) => {
      return {
        operation: 'add',
        exhibitName: rightNames[index],
        candidate: {
          name: n,
          versionRange: 'latest',
          type: payload.identity,
        },
        actions: [],
        text: '',
      };
    });

    const text = decompile(ruleObj);

    const params: Parameters<typeof FServiceAPI.InformalNode.putRules>[0] = {
      nodeId: informalNodeManagerPage.node_ID,
      additionalTestRule: text,
    };
    const { data, errCode, ret, msg }: {
      data: boolean;
      errCode: number;
      msg: string;
      ret: number;
    } = yield call(FServiceAPI.InformalNode.putRules, params);
    if (ret !== 0 || errCode !== 0 || !data) {
      return fMessage(msg, 'error');
    }
    fMessage(FI18n.i18nNext.tAuto('msg_new_test_exhibit_added'));
    yield put<FetchThemeListAction>({
      type: 'fetchThemeList',
      payload: {
        isRematch: true,
        isRestart: true,
      },
    });
  },
};
